export const openUrlInNewTab = (url: string) => {
  window.open(url, "_blank");
};
